import useArtistsApi from '🔗/api/artists';
import useFavoriteApi from '🔗/api/favorite';
import useDictApi from '🔗/api/dict';
import useLicensesApi from '🔗/api/licenses';
import usePlaylistsApi from '🔗/api/playlists';
import useTracksApi from '🔗/api/tracks';
import useReleasesApi from '🔗/api/releases';
import useShowcaseApi from '🔗/api/showcase';
import useUserApi from '🔗/api/user';
import useUsersApi from '🔗/api/users';
import useRolesApi from '🔗/api/roles';
import useEntityApi from '🔗/api/entity';
import useTgsApi from '🔗/api/tgs';

const api = {
    artists: () => useArtistsApi(),
    favorite: () => useFavoriteApi(),
    dict: () => useDictApi(),
    roles: () => useRolesApi(),
    licenses: () => useLicensesApi(),
    playlists: () => usePlaylistsApi(),
    tracks: () => useTracksApi(),
    releases: () => useReleasesApi(),
    showcase: () => useShowcaseApi(),
    user: () => useUserApi(),
    entity: () => useEntityApi(),
    users: () => useUsersApi(),
    tgs: () => useTgsApi()
}

export default api;